import {ApolloClient, createHttpLink, InMemoryCache} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import type {GqlConfig} from './client.interface';

export const createApolloClient = ({
  baseUrl,
  apiKey,
  supabaseClient,
}: GqlConfig) => {
  const httpLink = createHttpLink({
    uri: `${baseUrl}/graphql/v1`,
  });

  const authLink = setContext(async (_, {headers}) => {
    const {
      data: {session},
    } = await supabaseClient.auth.getSession();

    const accessToken = session?.access_token;

    return {
      headers: {
        ...headers,
        'Content-Type': 'application/json',
        apiKey,
        Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
      },
    };
  });

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {fetchPolicy: 'network-only'},
      watchQuery: {fetchPolicy: 'cache-and-network'},
    },
  });
};
